import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'circles',
  'invite-to-circle-by-guardian',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
    'guardians_proxies',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/circles/invite-guardian.js